var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class FabricCanvas {
    constructor(canvas, args) {
        this.objects = [];
        this.scale = 1;
        this.zoomed_width_pu = 0;
        this.zoomed_height_pu = 0;
        // [scale_x, 0, 0, scale_y, offset_x, offset_y];
        this.viewportTransform = [1, 0, 0, 1, 0, 0];
        this.canvas = canvas;
        const { backgroundColor, selection, controlsAboveOverlay, selectionLineWidth } = args;
        this.backgroundColor = backgroundColor;
        this.selection = selection;
        this.controlsAboveOverlay = controlsAboveOverlay;
        this.selectionLineWidth = selectionLineWidth;
    }
    get width() {
        var _a;
        return ((_a = this.canvas) === null || _a === void 0 ? void 0 : _a.width) || 0;
    }
    get height() {
        var _a;
        return ((_a = this.canvas) === null || _a === void 0 ? void 0 : _a.height) || 0;
    }
    on(eventName, listener) {
        switch (eventName) {
            case "mouse:down":
                this.canvas.addEventListener("mousedown", listener);
                break;
            case "mouse:move":
                this.canvas.addEventListener("mousemove", listener);
                break;
            case "mouse:up":
                this.canvas.addEventListener("mouseup", listener);
                break;
            case "mouse:wheel":
                this.canvas.addEventListener("wheel", listener);
                break;
        }
    }
    off(eventName, listener) {
        switch (eventName) {
            case "mouse:down":
                this.canvas.removeEventListener("mousedown", listener);
                break;
            case "mouse:move":
                this.canvas.removeEventListener("mousemove", listener);
                break;
            case "mouse:up":
                this.canvas.removeEventListener("mouseup", listener);
                break;
            case "mouse:wheel":
                this.canvas.removeEventListener("wheel", listener);
                break;
        }
    }
    getObjects() {
        return this.objects;
    }
    remove(obj) {
        const idx = this.objects.findIndex((o) => o.uuid === obj.uuid);
        if (idx > -1)
            this.objects.splice(idx, 1);
    }
    add(obj) {
        obj.added = true;
        obj.dirty = true;
        this.objects.push(obj);
    }
    getPointer(e) {
        if (!this.canvas)
            return undefined;
        const pt = { x: e.clientX, y: e.clientY };
        const rect = this.canvas.getBoundingClientRect();
        const ret = {
            // x: (pt.x - ox)/ this.scale,
            // y: (pt.y -oy ) / this.scale
            x: (pt.x - rect.left) / this.scale,
            y: (pt.y - rect.top) / this.scale
        };
        return ret;
    }
    requestRenderAll() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.renderAll();
        });
    }
    getZoom() { return this.scale; }
    get cssSize() {
        return { width: this.zoomed_width_pu, height: this.zoomed_height_pu };
    }
    setZoom(scale) {
        this.scale = scale;
        this.viewportTransform[0] = scale;
        this.viewportTransform[3] = scale;
        if (this.canvas) {
            // console.log("setZoom", this.canvas.id, scale);
            const width = this.zoomed_width_pu;
            const height = this.zoomed_height_pu;
            this.canvas.width = width;
            this.canvas.height = height;
            // this.renderAll();
        }
        // this.canvas.style.scale = `${scale}`;
    }
    setSize(width, height) {
        this.zoomed_height_pu = height;
        this.zoomed_width_pu = width;
        if (this.canvas) {
            // console.log(`view size resized = ${0} x ${0}`);
            // console.log("setSize", this.canvas.id, width, height);
            // this.canvas.width = width;
            // this.canvas.height = height;
            this.canvas.style.width = `${width}px`;
            this.canvas.style.height = `${height}px`;
            this.canvas.style.backgroundColor = this.backgroundColor;
            // this.setZoom(this.scale);
        }
    }
    dispose() {
        this.objects = [];
    }
    setViewportTransform(vpt) {
        const ctx = this.canvas.getContext("2d");
        this.viewportTransform = [...vpt];
        this.renderAll();
    }
    renderAll() {
        if (this.objects && this.canvas) {
            const ctx = this.canvas.getContext("2d");
            if (ctx) {
                ctx.setTransform(...this.viewportTransform);
                ctx.clearRect(0, 0, this.canvas.width / this.scale, this.canvas.height / this.scale);
                for (let i = 0, ln = this.objects.length; i < ln; i++) {
                    const obj = this.objects[i];
                    obj.draw(ctx, this.scale);
                }
            }
        }
    }
    renderObject(obj) {
        if (this.canvas) {
            const ctx = this.canvas.getContext("2d");
            if (ctx) {
                ctx.setTransform(...this.viewportTransform);
                obj.draw(ctx, this.scale);
            }
        }
    }
}
//# sourceMappingURL=FabricCanvas.js.map